/**
 * The ShowCallInfoResult class
 */
export class ShowCallInfoResult {
  public ExtID: string | null = null;
  public VTID: number | null = null;
  public FMExtID: string | null = null;
  public DateFrom: Date | null = null;
  public DateTo: Date | null = null;
  public TimeFrom: Date | null = null;
  public TimeTo: Date | null = null;
  public Duration: number | null = null;
  public Date: Date | null = null;
  public Arrival: Date | null = null;
  public DrivingTime: number | null = null;
  public Distance: number | null = null;
  public State: number | null = null;
  public Condition: number | null = null;
  public Sequence: number | null = null;
  public CustomerID: string | null = null;
  public Name: string | null = null;
  public Name2: string | null = null;
  public Title: string | null = null;
  public ContactPerson: string | null = null;
  public Phone1: string | null = null;
  public Phone2: string | null = null;
  public Country: string | null = null;
  public ZIP: string | null = null;
  public City: string | null = null;
  public Street: string | null = null;
  public CallInfo1: string | null = null;
  public CallInfo2: string | null = null;
  public NotFound: number | null = null;
  public SaveStatus: number | null = null;
}

export enum ShowCallInfoResultState {
  Recorded = 1,
  Confirmed = 2,
  Fixed = 3,
  Onroute = 4,
  Processing = 5,
  Complete = 6
}

export enum ShowCallInfoResultSaveStatus {
  Incomplete = 0,
  Recorded = 1,
  Confirmed = 2,
  Fixed = 3,
  Onroute = 4,
  Processing = 5,
  Complete = 6
}